module.exports = __webpack_public_path__ + "static/media/poster.21ae7574.png";